var config = {
    API_KEY : "?key=884857e3-ef38-4d68-80bd-c25f917b06c9",
    SECRET_KEY : '56789',
    KEY_2 : '101010'
  }

module.exports = config

